export default __webpack_public_path__ + "static/media/Audi_Q5_Car_Lora_Thumb.a7e3f2f1.jpg";